import { useTranslation } from "react-i18next";
import { Reveal } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const Faq = () => {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true });

  return (
    <section id="faq" className="relative bg-[#0D0F12] px-6 py-28 lg:px-12 lg:py-40" data-testid="faq-section">
      <div className="mx-auto grid max-w-7xl gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="font-code text-[11px] uppercase tracking-[0.35em] text-[#D6705A]">{t("faq.overline")}</p>
            <h2 className="mt-4 font-display text-4xl font-light leading-tight text-[#F9F8F6] sm:text-5xl lg:text-6xl">
              {t("faq.h2pre")} <em className="italic text-[#D6705A]">{t("faq.h2em")}</em>
            </h2>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-[#A0A0A0] md:text-base" data-testid="faq-subtitle">
              {t("faq.subtitle")}
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1} className="lg:col-span-7">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {items.map((item, i) => (
              <AccordionItem key={item.q} value={`faq-${i}`} className="mb-3 rounded-xl border border-white/10 px-5 transition-colors duration-300 data-[state=open]:border-[#D6705A]/40" data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  className="py-5 font-display text-lg font-light text-[#F9F8F6] transition-colors duration-300 hover:text-[#D6705A] hover:no-underline md:text-xl [&>svg]:text-[#666] [&[data-state=open]>svg]:text-[#D6705A]"
                  data-testid={`faq-trigger-${i}`}
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-content-${i}`}>
                  <p className="max-w-2xl pb-2 text-sm leading-relaxed text-[#A0A0A0] md:text-base">{item.a}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};
